import { createSlice } from "@reduxjs/toolkit";

export const candidateFiltersSlice = createSlice({
    name: 'candidateFilters',
    initialState: {
        value: {
            sourceFilter: { value: "", label: "--" },
            fitmentFilter: { value: "", label: "--" },
            timeToJoinFilter: { value: "", label: "--" },
            statusFilter: { value: "", label: "--" },
            currentStatusFilter: { value: "", label: "--" },
            preferredLocationFilter: { value: "", label: "--" },
            startDate: "",
            endDate: "",
            updated: false,
            page: 1,
            page_size: 10,
        },
    },
    reducers: {
        updateCandidateFilters: (state, action) => {
            state.value = action.payload;

        }
    }
})

export const selectCandidateFilters = (state) => state.candidateFilters.value

export const { updateCandidateFilters } = candidateFiltersSlice.actions

export default candidateFiltersSlice.reducer